import o from "./index2.js";
const e = o;
export {
  e as default
};
//# sourceMappingURL=index.js.map
